import Swal from 'sweetalert2'

export const apiErrorHandler = (e, default_token = false) => {
  if (e.message === 'Network Error') {
    Swal.fire({
      icon: 'error',
      title: 'لطفا اتصال اینترنت را بررسی فرمایید',
      allowOutsideClick: false,
    })
  } else if (e.response?.['status'] === 400) {
    if (e.response?.data['errors']) {
      Swal.fire({
        icon: 'error',
        text: '.لطفا خطاهای به وجود آمده را رفع کنید',
      })
      return { status: 400, error: e.response?.data['errors'] }
    } else {
      return { status: 400, error: e.response?.data['message'] }
    }
  } else if (e.response?.['status'] === 403) {
    if (e.response?.data['errors']?.['verify_code']) {
      return { status: 403, error: e.response?.data['errors'] }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'خطای دسترسی',
        text: 'شما به این بخش دسترسی ندارید',
      })
    }
  } else if (e.response?.['status'] === 404) {
    window.location.pathname = '/404'
  } else if (e.response?.['status'] === 500 || e.response?.['status'] === 503) {
    window.location.pathname = '/500'
  } else if (e.response?.['status'] === 401) {
    Swal.fire({
      icon: 'error',
      title: 'عدم دسترسی',
      text: 'احراز هویت نامعتبر',
    })
    window.location.replace(default_token ? '/' : '/admin')
    localStorage.removeItem('Token')
  }
}
